import pollForNewState from '../../../../../shared/lib/poll-for-new-state';
import { endSpinner } from '../../../../Account/redux/actions';

export function handlePollingForCookie(cookieName, id, tab) {
  // TODO @ma: references to cookie can be removed if loading spinner is removed after downloading
  // a data-export
  let cookie = null; // eslint-disable-line no-unused-vars
  const initialPromise = () => new Promise((resolve) => {
    let cookies = [];

    try {
      cookies = document.cookie.split(';').map(c => c.trim());// check for multiple cookies (trim needed if multiple cookies present)
    } catch (e) {
      this.logErrors('something went wrong with trying to fetch cookies', e);
    }

    return resolve({ result: { data: cookies } });
  });

  const handleCookie = (data) => {
    let cookieValue = '{}';
    const downloadCookie = data.filter((c) => {
      const [name, value] = c.split('=');
      if (name === `${cookieName}`) {
        cookieValue = value;
        return true;
      }
      return false;
    });
    if (downloadCookie.length) {
      cookie = downloadCookie[0];
    }
    let decodedValue = {};
    try {
      decodedValue = decodeURIComponent(cookieValue); // was encoded server side
      decodedValue = JSON.parse(decodedValue); // gotta get back into an object to work with it
    } catch (e) {
      this.logErrors('something went wrong with trying to decode uri component', e);
    }

    const {
      downloadStatus,
    } = decodedValue;
    if (downloadStatus === 'finished') {
      if (tab.json && tab.json.status === 'error') {
        tab.close();
        // no error from the stream, error from the exports service
        this.createDataExportEvent('download_failed', id);
      } else {
        this.createDataExportEvent('download_succeeded', id);
      }
      this.props.dispatch(endSpinner());
      return true;
    } else if (downloadStatus === 'error') {
      // error with the stream
      this.createDataExportEvent('download_failed', id);
      this.props.dispatch(endSpinner());
      return true;
    } // end have found the correct cookie
    return false;
  };
  const killTimer = this.killCookieUpdateTimer;
  const setTimerRef = this.setCookieTimerRef;
  const exitCallbacks = [handleCookie];
  const interval = 1000;
  const displayName = this.props.location && this.props.location.pathname;
  pollForNewState({
    initialPromise,
    killTimer,
    setTimerRef,
    exitCallbacks,
    interval,
    displayName,
  });
}



// WEBPACK FOOTER //
// ./modules/DataExports/components/lib/helpers/handlePollingForCookie.js